import { render, staticRenderFns } from "./ScreenCapCanvas.vue?vue&type=template&id=1935d282&scoped=true&"
import script from "./ScreenCapCanvas.vue?vue&type=script&lang=js&"
export * from "./ScreenCapCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCapCanvas.vue?vue&type=style&index=0&id=1935d282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935d282",
  null
  
)

export default component.exports